export default __webpack_public_path__ + "static/media/Poppins-Bold.cdb29a5d.ttf";